import { InjectionToken, Provider } from '@angular/core';
import { BusinessRegion, BusinessRegionResponseData, CitySearchSuggestion, CustomBaseStore } from '@city/const';
import { ActionReducerMap } from '@ngrx/store';
import { CustomPointOfService } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import {
  BASE_STORE,
  BASE_STORE_SHOPS,
  BUSINESS_REGION,
  CITY_SEARCH,
  CURRENT_POINT_BUSINESS_REGION,
  CityState,
} from '../city-state';
import { reducer as activeBaseStoreReducer } from './active-base-store.reducer';
import { reducer as cityReducer } from './city.reducer';
import { reducer as geoPointReducer } from './geo-point.reducer';
import { reducer as tempBaseStoreReducer } from './temp-base-store.reducer';

export type CityReducers = Omit<CityState, 'callback'>;

export function getReducers(): ActionReducerMap<CityReducers> {
  return {
    activeBaseStore: activeBaseStoreReducer,
    businessRegion: StateUtils.loaderReducer<BusinessRegion>(BUSINESS_REGION),
    currentPointBusinessRegion: StateUtils.loaderReducer<BusinessRegionResponseData>(CURRENT_POINT_BUSINESS_REGION),
    baseStores: StateUtils.loaderReducer<CustomBaseStore[]>(BASE_STORE),
    baseStoreShops: StateUtils.entityLoaderReducer<CustomPointOfService[]>(BASE_STORE_SHOPS),
    userGeoPoint: geoPointReducer,
    city: cityReducer,
    tempBaseStore: tempBaseStoreReducer,
    citySuggestions: StateUtils.loaderReducer<CitySearchSuggestion[]>(CITY_SEARCH),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<CityReducers>> = new InjectionToken<
  ActionReducerMap<CityReducers>
>('CityReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
